import * as sdk from "firebase/auth";
import { isLocalPreview } from "./previewMode";
import { previewAuthChanged, previewUsers, selectPreviewUser, previewAuth } from "./previewStore";

export const GoogleAuthProvider = sdk.GoogleAuthProvider;
export const onAuthStateChanged = (auth, callback) => isLocalPreview ? previewAuthChanged(callback) : sdk.onAuthStateChanged(auth, callback);
export const signOut = auth => isLocalPreview ? previewAuth.signOut() : sdk.signOut(auth);
export const signInWithPopup = async (auth, provider) => {
  if (!isLocalPreview) return sdk.signInWithPopup(auth, provider);
  selectPreviewUser(previewUsers[0].uid);
  return { user: previewAuth.currentUser };
};
